module.exports = __webpack_public_path__ + "img/logo_pulda.11c4bc26.svg";